"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Labels = void 0;

var _form = require("@clayui/form");

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _label2 = _interopRequireDefault(require("@clayui/label"));

var _shared = require("@clayui/shared");

var _react = _interopRequireWildcard(require("react"));

var _excluded = ["allowsCustomLabel", "aria-activedescendant", "ariaDescriptionId", "closeButtonAriaLabel", "disabled", "inputName", "insetAfter", "labels", "lastChangesRef", "locator", "onChange", "onFocusChange", "onLabelsChange", "placeholder", "spritemap", "suggestionList", "value"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DELIMITER_KEYS = ['Enter', ','];
var KeysNavigation = [_shared.Keys.Left, _shared.Keys.Right, _shared.Keys.Up, _shared.Keys.Down];
var KeysSides = [_shared.Keys.Left, _shared.Keys.Right];
var counterUid = 0;

var Labels = /*#__PURE__*/_react.default.forwardRef(function Labels(_ref, ref) {
  var allowsCustomLabel = _ref.allowsCustomLabel,
      activeDescendant = _ref['aria-activedescendant'],
      ariaDescriptionId = _ref.ariaDescriptionId,
      closeButtonAriaLabel = _ref.closeButtonAriaLabel,
      disabled = _ref.disabled,
      inputName = _ref.inputName,
      _ = _ref.insetAfter,
      labels = _ref.labels,
      lastChangesRef = _ref.lastChangesRef,
      locator = _ref.locator,
      _onChange = _ref.onChange,
      onFocusChange = _ref.onFocusChange,
      onLabelsChange = _ref.onLabelsChange,
      placeholder = _ref.placeholder,
      spritemap = _ref.spritemap,
      suggestionList = _ref.suggestionList,
      value = _ref.value,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var inputRef = (0, _react.useRef)(null);
  var labelsRef = (0, _react.useRef)(null);
  var lastItemRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      isLabelFocused = _useState2[0],
      setIsLabelFocused = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      lastFocusedItem = _useState4[0],
      setLastFocusedItem = _useState4[1];

  var inputElementRef = ref || inputRef;
  var labelId = (0, _shared.useId)();

  var getSourceItemByLabel = function getSourceItemByLabel(label) {
    return suggestionList.find(function (item) {
      return item[locator.label] === label;
    });
  };

  var getNewItem = function getNewItem(value) {
    var _ref2;

    counterUid++;
    return getSourceItemByLabel(value) || (_ref2 = {}, _defineProperty(_ref2, locator.label, value), _defineProperty(_ref2, locator.value, value), _defineProperty(_ref2, "key", "key_".concat(counterUid)), _ref2);
  };

  var onRemove = (0, _react.useCallback)(function (label, index) {
    if (labelsRef.current) {
      var focusableElements = Array.from(labelsRef.current.querySelectorAll('button'));
      var activeElement = document.activeElement.tagName === 'SPAN' ? document.activeElement.querySelector('button') : document.activeElement;
      var position = focusableElements.indexOf(activeElement);
      var closeElement = focusableElements[focusableElements.length - 1 > position ? position + 1 : position - 1];

      if (closeElement) {
        closeElement.focus();
        setLastFocusedItem(closeElement.getAttribute('id'));
      } else {
        var _inputElementRef$curr;

        (_inputElementRef$curr = inputElementRef.current) === null || _inputElementRef$curr === void 0 ? void 0 : _inputElementRef$curr.focus();
        setLastFocusedItem(null);
      }
    }

    lastChangesRef.current = {
      action: 'removed',
      label: label
    };
    onLabelsChange(labels.filter(function (_, itemIndex) {
      return itemIndex !== index;
    }));
  }, [labels]);
  return /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, null, /*#__PURE__*/_react.default.createElement(_form.ClayInput.Group, null, /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    "aria-labelledby": otherProps['aria-labelledby'],
    className: "d-contents",
    onFocus: function onFocus(event) {
      return setLastFocusedItem(event.target.getAttribute('id'));
    },
    onKeyDown: function onKeyDown(event) {
      if (KeysNavigation.includes(event.key)) {
        // Query labels and buttons to exclude the label that are
        // focusable the navigation order depends on which orientation
        // the navigation is happen.
        // - Left and Right. Query all elements.
        // - Up and Down. Query for elements of the same type as the
        //   last focused element.
        var focusableElements = Array.from(event.currentTarget.querySelectorAll(KeysSides.includes(event.key) ? '[role=gridcell][tabindex], button' : lastFocusedItem !== null && lastFocusedItem !== void 0 && lastFocusedItem.includes('span') ? '[role=gridcell][tabindex]' : 'button'));
        var position = focusableElements.indexOf(document.activeElement);
        var key = KeysSides.includes(event.key) ? _shared.Keys.Left : _shared.Keys.Up;
        var label = focusableElements[event.key === key ? position - 1 : position + 1];

        if (label) {
          setLastFocusedItem(label.getAttribute('id'));
          label.focus();
        }
      }

      if (event.key === _shared.Keys.Home || event.key === _shared.Keys.End) {
        var isLabel = lastFocusedItem.includes('span');

        if (isLabel && event.key === _shared.Keys.Home || !isLabel && event.key === _shared.Keys.End) {
          return;
        }

        var _label = event.currentTarget.querySelector("[id=".concat(lastFocusedItem === null || lastFocusedItem === void 0 ? void 0 : lastFocusedItem.replace(isLabel ? 'span' : 'close', event.key === _shared.Keys.Home ? 'span' : 'close'), "]"));

        if (_label) {
          setLastFocusedItem(_label.getAttribute('id'));

          _label.focus();
        }
      }
    },
    prepend: true,
    ref: function ref(_ref5) {
      labelsRef.current = _ref5;
    },
    role: "grid",
    shrink: true
  }, labels.map(function (item, i) {
    var _item;

    var uid = (_item = item[locator.id]) !== null && _item !== void 0 ? _item : item[locator.value];
    var id = "".concat(labelId, "-label-").concat(uid, "-span");
    var closeId = "".concat(labelId, "-label-").concat(uid, "-close");
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: id
    }, /*#__PURE__*/_react.default.createElement(_label2.default, {
      className: isLabelFocused === id ? 'focus' : undefined,
      onKeyDown: function onKeyDown(_ref3) {
        var key = _ref3.key;

        if (key === _shared.Keys.Backspace) {
          onRemove(item[locator.label], i);
        }
      },
      role: "row",
      spritemap: spritemap,
      tabIndex: -1,
      withClose: false
    }, /*#__PURE__*/_react.default.createElement(_label2.default.ItemExpand, {
      "aria-describedby": ariaDescriptionId,
      id: id,
      onBlur: function onBlur() {
        return setIsLabelFocused(null);
      },
      onFocus: function onFocus() {
        return setIsLabelFocused(id);
      },
      role: "gridcell",
      style: {
        outline: 'none'
      },
      tabIndex: lastFocusedItem === null && i === 0 || lastFocusedItem === id ? 0 : -1
    }, item[locator.label]), /*#__PURE__*/_react.default.createElement(_label2.default.ItemAfter, {
      role: "gridcell"
    }, /*#__PURE__*/_react.default.createElement("button", {
      "aria-label": (0, _shared.sub)(closeButtonAriaLabel, [item[locator.label]]),
      className: "close",
      disabled: disabled,
      id: closeId,
      onClick: function onClick() {
        return onRemove(item[locator.label], i);
      },
      ref: function ref(_ref4) {
        if (i === labels.length - 1) {
          lastItemRef.current = _ref4;
        }
      },
      tabIndex: lastFocusedItem === closeId ? 0 : -1,
      type: "button"
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      spritemap: spritemap,
      symbol: "times-small"
    })))), inputName && /*#__PURE__*/_react.default.createElement("input", {
      name: inputName,
      type: "hidden",
      value: item[locator.value]
    }));
  })), /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    prepend: true
  }, /*#__PURE__*/_react.default.createElement("input", _extends({}, otherProps, {
    "aria-activedescendant": activeDescendant,
    className: "form-control-inset",
    disabled: disabled,
    onBlur: function onBlur(event) {
      if (otherProps.onBlur) {
        otherProps.onBlur(event);
      }

      onFocusChange(false);
    },
    onChange: function onChange(event) {
      var value = event.target.value;
      event.target.value = allowsCustomLabel ? value.replace(',', '') : value;

      _onChange(event);
    },
    onFocus: function onFocus(event) {
      if (otherProps.onFocus) {
        otherProps.onFocus(event);
      }

      onFocusChange(true);
    },
    onKeyDown: function onKeyDown(event) {
      if (otherProps.onKeyDown) {
        otherProps.onKeyDown(event);
      }

      var key = event.key;

      if (key === _shared.Keys.Backspace && !value) {
        event.preventDefault();
      }

      if (key === _shared.Keys.Enter && activeDescendant) {
        return;
      }

      if (allowsCustomLabel && value.trim() && DELIMITER_KEYS.includes(key)) {
        event.preventDefault();
        lastChangesRef.current = {
          action: 'added',
          label: value
        };
        onLabelsChange([].concat(_toConsumableArray(labels), [getNewItem(value)])); // @ts-ignore

        _onChange({
          target: {
            value: ''
          }
        });
      } else if (!value && key === _shared.Keys.Backspace && inputElementRef.current && lastItemRef.current) {
        inputElementRef.current.blur();
        lastItemRef.current.focus();
      }
    },
    onPaste: function onPaste(event) {
      if (otherProps.onPaste) {
        otherProps.onPaste(event);
      }

      if (event.defaultPrevented) {
        return;
      }

      var pastedText = event.clipboardData.getData('Text');
      var pastedItems = pastedText.split(',').map(function (itemLabel) {
        return getNewItem(itemLabel.trim());
      }).filter(Boolean);

      if (allowsCustomLabel && pastedItems.length > 0) {
        event.preventDefault();
        onLabelsChange([].concat(_toConsumableArray(labels), _toConsumableArray(pastedItems)));
      }
    },
    placeholder: labels.length ? undefined : placeholder,
    ref: inputElementRef,
    type: "text",
    value: value
  })))));
});

exports.Labels = Labels;